module.exports = __webpack_public_path__ + "static/hps.c63049e1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/resume/hps.jpeg
// module id = 474
// module chunks = 114276838955818